/**
 * Converts string to "kebab case"
 * https://en.wikipedia.org/wiki/Letter_case#Special_case_styles
 *
 * Based on https://gist.github.com/thevangelist/8ff91bac947018c9f3bfaad6487fa149
 */
export const convertToKebabCase = (string: string) => {
  return string?.replace(/\s+/g, '-')?.toLowerCase();
};
